module.exports = __webpack_public_path__ + "static/media/school.53c133e1.jpg";